// extracted by mini-css-extract-plugin
export var faq = "faq-module--faq--bedd1";
export var faq_a = "faq-module--faq_a--2a3f6";
export var faq_items = "faq-module--faq_items--1fb78";
export var faq_q = "faq-module--faq_q--a5a38";
export var help = "faq-module--help--0f38a";
export var hero = "faq-module--hero--2bb14";
export var image = "faq-module--image--5d29e";
export var title = "faq-module--title--30c3a";